"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "catanzaro": {
    "fedfd6a5": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "skipSearch": false
    }],
    "bellavista": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "320ac0ff": [{
      "hkey": "71e7111f",
      "slug": "catanzaro-lido",
      "name": "Catanzaro Lido",
      "primary": true,
      "skipSearch": false
    }],
    "catanzaro-lido-centro": [{
      "hkey": "71e7111f",
      "slug": "catanzaro-lido",
      "name": "Catanzaro Lido",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "a9a1bb48": [{
      "hkey": "7e5454cf",
      "slug": "sala",
      "name": "Sala",
      "primary": true,
      "skipSearch": false
    }],
    "catanzaro-sala": [{
      "hkey": "7e5454cf",
      "slug": "sala",
      "name": "Sala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "ab916250": [{
      "hkey": "d662a634",
      "slug": "cava-cuculera-nobile",
      "name": "Cava-Cuculera Nobile",
      "primary": true,
      "skipSearch": false
    }],
    "cava": [{
      "hkey": "d662a634",
      "slug": "cava-cuculera-nobile",
      "name": "Cava-Cuculera Nobile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5eb2d712": [{
      "hkey": "71e7111f",
      "slug": "catanzaro-lido",
      "name": "Catanzaro Lido",
      "primary": true,
      "skipSearch": false
    }],
    "cz-lido-giovino-porto": [{
      "hkey": "71e7111f",
      "slug": "catanzaro-lido",
      "name": "Catanzaro Lido",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "795ae3ed": [{
      "hkey": "0fa57d21",
      "slug": "gagliano-mater-domini",
      "name": "Gagliano-Mater Domini",
      "primary": true,
      "skipSearch": false
    }],
    "gagliano": [{
      "hkey": "0fa57d21",
      "slug": "gagliano-mater-domini",
      "name": "Gagliano-Mater Domini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "30c1f30b": [{
      "hkey": "34e5077b",
      "slug": "corvo-fortuna",
      "name": "Corvo-Fortuna",
      "primary": true,
      "skipSearch": false
    }],
    "il-corvo": [{
      "hkey": "34e5077b",
      "slug": "corvo-fortuna",
      "name": "Corvo-Fortuna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "5b34409a": [{
      "hkey": "0726c083",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }],
    "indipendenza-c-so-mazzini": [{
      "hkey": "0726c083",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "7575310c": [{
      "hkey": "71e7111f",
      "slug": "catanzaro-lido",
      "name": "Catanzaro Lido",
      "primary": true,
      "skipSearch": false
    }],
    "lungomare": [{
      "hkey": "71e7111f",
      "slug": "catanzaro-lido",
      "name": "Catanzaro Lido",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "3c61c6f3": [{
      "hkey": "0fa57d21",
      "slug": "gagliano-mater-domini",
      "name": "Gagliano-Mater Domini",
      "primary": true,
      "skipSearch": false
    }],
    "mater-domini": [{
      "hkey": "0fa57d21",
      "slug": "gagliano-mater-domini",
      "name": "Gagliano-Mater Domini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "58d8d38b": [{
      "hkey": "0fa57d21",
      "slug": "gagliano-mater-domini",
      "name": "Gagliano-Mater Domini",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "c01d2472",
      "slug": "sant-antonio",
      "name": "Sant'Antonio",
      "primary": false,
      "skipSearch": false
    }],
    "mater-domini-s-antonio": [{
      "hkey": "0fa57d21",
      "slug": "gagliano-mater-domini",
      "name": "Gagliano-Mater Domini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "a1d417e2": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "skipSearch": false
    }],
    "pistoia": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a641447": [{
      "hkey": "267e3e41",
      "slug": "pontegrande",
      "name": "Pontegrande",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-grande-siano": [{
      "hkey": "267e3e41",
      "slug": "pontegrande",
      "name": "Pontegrande",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "06af16dd": [{
      "hkey": "65b999b4",
      "slug": "pontepiccolo",
      "name": "Pontepiccolo",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-piccolo": [{
      "hkey": "65b999b4",
      "slug": "pontepiccolo",
      "name": "Pontepiccolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9e1f10dc": [{
      "hkey": "34e5077b",
      "slug": "corvo-fortuna",
      "name": "Corvo-Fortuna",
      "primary": true,
      "skipSearch": false
    }],
    "q-re-corvo-fortuna": [{
      "hkey": "34e5077b",
      "slug": "corvo-fortuna",
      "name": "Corvo-Fortuna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1a8a7245": [{
      "hkey": "29dc6735",
      "slug": "san-leonardo",
      "name": "San Leonardo",
      "primary": true,
      "skipSearch": false
    }],
    "quartiere-s-leonardo": [{
      "hkey": "29dc6735",
      "slug": "san-leonardo",
      "name": "San Leonardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "861b01c5": [{
      "hkey": "e7f49f53",
      "slug": "sant-elia",
      "name": "Sant'Elia",
      "primary": true,
      "skipSearch": false
    }],
    "s-elia-pitera": [{
      "hkey": "e7f49f53",
      "slug": "sant-elia",
      "name": "Sant'Elia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "805fa176": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "skipSearch": false
    }],
    "san-janni": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa2c8fbb": [{
      "hkey": "29dc6735",
      "slug": "san-leonardo",
      "name": "San Leonardo",
      "primary": true,
      "skipSearch": false
    }],
    "schipani": [{
      "hkey": "29dc6735",
      "slug": "san-leonardo",
      "name": "San Leonardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "faa4797c": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "skipSearch": false
    }],
    "signorello": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d88758e": [{
      "hkey": "65b999b4",
      "slug": "pontepiccolo",
      "name": "Pontepiccolo",
      "primary": true,
      "skipSearch": false
    }],
    "stadio": [{
      "hkey": "65b999b4",
      "slug": "pontepiccolo",
      "name": "Pontepiccolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }],
    "d38a0c01": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "skipSearch": false
    }],
    "via-barrio": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "687ce504": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "skipSearch": false
    }],
    "via-massara": [{
      "hkey": "5f1fb266",
      "slug": "catanzaro",
      "name": "Catanzaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5ae89d41": [{
      "hkey": "c01d2472",
      "slug": "sant-antonio",
      "name": "Sant'Antonio",
      "primary": true,
      "skipSearch": false
    }],
    "viale-de-filippis": [{
      "hkey": "c01d2472",
      "slug": "sant-antonio",
      "name": "Sant'Antonio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "catanzaro"
    }]
  }
};
exports["default"] = _default;